import React, { useEffect, useRef, useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import useForm, { Form } from "../../../../../hooks/useForm";
import Controls from "../../../../../components/form/controls/Controls";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  CircularProgress,
  Fab,
  Tooltip,
  Typography,
} from "@mui/material";
import { getReleaseGroup } from "../../../../../apis/VersionRelease/group.api";
import { validationReleaseSpeakerVersionInput } from "../../../utils/validateInput";
import { getReleaseTypeSpeaker } from "../../../../../apis/VersionRelease/typeSpeaker.api";
import { getPreSignUploadFss } from "../../../../../apis/FLF/icon.api";
import { green, red } from "@mui/material/colors";
import CheckIcon from "@mui/icons-material/Check";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import CloudOffIcon from "@mui/icons-material/CloudOff";
import { NotifyConfirm, Toast } from "../../../../../components/notify/Notify";
import { uploadFileToFSS } from "../../../../../apis/FSS/upload.fss";
import calculateMD5Checksum from "../../../../../utils/md5.checksum.utils";

const styleDiv = {
  borderRadius: "4px",
  margin: "30px 0",
  padding: "15px",
  boxShadow:
    "0px 3px 3px -2px rgba(0,0,0,0.2), 0px 3px 4px 0px rgba(0,0,0,0.14), 0px 1px 8px 0px rgba(0,0,0,0.12)",
};

const speakerTypeOption = [
  {
    id: "setup",
    name: "Setup",
  },
  {
    id: "delete",
    name: "Delete",
  },
];

const envOption = [
  {
    id: "staging",
    name: "staging",
  },
  {
    id: "production",
    name: "production",
  },
];

const initialValue = {
  id: "",
  name: "",
  pathFile: "",
  checksum: "",
  packageName: "",
  action: "",
  environment: "",
  versionName: "",
  versionCode: "",
  typeSpeakerId: "",
  releaseGroupIds: [],
};

const statusUploadFile = {
  nothing: "nothing",
  picked: "picked",
  success: "success",
  error: "error",
};

const showIconUploadByStatus = (statusUpload) => {
  if (statusUpload === statusUploadFile.success) {
    return <CheckIcon />;
  } else if (statusUpload === statusUploadFile.error) {
    return <CloudOffIcon />;
  } else {
    return <CloudUploadIcon />;
  }
};

function ReleaseSpeakerVersionForm(props) {
  const {
    addOrEdit,
    recordForEdit,
    releaseTypeSpeakerId,
    environmentId,
    errorsForm,
  } = props;
  const [valueAddNew, setValueAddNew] = useState(initialValue);
  const fileInputRef = useRef(null);
  const [files, setFiles] = useState([]);
  const [groups, setGroups] = useState([]);
  const [typeSpeakers, setTypeSpeakers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [statusUpload, setStatusUpload] = useState(statusUploadFile.nothing);

  const buttonSx = {
    ...(statusUpload === statusUploadFile.success && {
      bgcolor: green[500],
      "&:hover": {
        bgcolor: green[700],
      },
    }),
    ...(statusUpload === statusUploadFile.error && {
      bgcolor: red[500],
      "&:hover": {
        bgcolor: red[700],
      },
    }),
  };

  // validation input permission
  const validateFLFReleaseSpeakerVersionForm = (fieldValues = values) => {
    let temp = validationReleaseSpeakerVersionInput(fieldValues, { ...errors });

    setErrors({
      ...temp,
    });

    if (fieldValues === values)
      return Object.values(temp).every((x) => x === "");
  };

  const { values, setValues, errors, setErrors, handleInputChange, resetForm } =
    useForm(
      {
        ...initialValue,
        typeSpeakerId: releaseTypeSpeakerId,
        environment: environmentId,
      },
      true,
      validateFLFReleaseSpeakerVersionForm
    );

  useEffect(() => {
    getReleaseTypeSpeaker({}, (result) => {
      setTypeSpeakers([...result.list]);
    });
    // * Get list group
    getReleaseGroup({}, (result) => {
      setGroups([...result.list]);
    });
  }, []);

  useEffect(() => {
    setErrors({
      ...errorsForm,
    });
  }, [errorsForm, setErrors]);

  useEffect(() => {
    if (recordForEdit !== null) {
      const releaseGroupIds = recordForEdit.releaseGroups.map(
        (releaseGroup) => releaseGroup.id
      );
      recordForEdit.releaseGroupIds = releaseGroupIds;
      console.log("recordForEdit", recordForEdit);
      setValues({
        ...recordForEdit,
        releaseGroupIds,
      });
    } else {
      setValues({
        ...valueAddNew,
      });
      setErrors({});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [recordForEdit]);

  const onSubmit = (e) => {
    e.preventDefault();
    if (validateFLFReleaseSpeakerVersionForm()) {
      if (!values.pathFile || !values.checksum) {
        NotifyConfirm(
          "warning",
          "Are you submit it ?",
          (result) => {
            if (result.isConfirmed) {
              addOrEdit({ ...values }, resetForm);
              setValueAddNew(initialValue);
            }
          },
          "File chưa được upload !!"
        );
      } else {
        addOrEdit({ ...values }, resetForm);
        setValueAddNew(initialValue);
      }
    }
  };

  const handleOnChange = (e) => {
    handleInputChange(e);

    if (!recordForEdit) {
      const { name, value, type } = e.target;
      setValueAddNew({
        ...valueAddNew,
        [name]: type === "number" ? +value : value,
      });
    }
  };

  const handleFile = (e) => {
    fileInputRef.current?.setAttribute("value", "");
    setFiles(e.target.files);
    setErrors((errors) => ({ ...errors, pathFile: "" }));
    setValues((values) => ({ ...values, checksum: "" }));
    setStatusUpload(statusUploadFile.picked);
    setLoading(false);
  };

  const handleChangeFile = () => {
    fileInputRef.current?.click();
  };

  const handleButtonClick = () => {
    if (!files.length) {
      Toast("warning", "Vui lòng chọn file cần upload");
    } else {
      if (!loading) {
        setLoading(true);
        setStatusUpload(statusUploadFile.uploading);

        getPreSignUploadFss({ pathName: files[0]?.name }, (result) => {
          if (result.data.status === 200) {
            uploadFileToFSS(
              result.data.data.data.presigned_url,
              files[0],
              async (result) => {
                if (result.status === 200) {
                  const md5Checksum = await calculateMD5Checksum(files[0]);
                  setValues((values) => ({
                    ...values,
                    pathFile: files[0]?.name,
                    checksum: md5Checksum,
                  }));
                  setErrors((errors) => ({
                    ...errors,
                    pathFile: "",
                    checksum: "",
                  }));
                  setStatusUpload(statusUploadFile.success);
                  setLoading(false);
                } else {
                  setStatusUpload(statusUploadFile.error);
                  setLoading(false);
                }

                setFiles([]);
              }
            );
          }
        });
      }
    }
  };
  return (
    <Form onSubmit={onSubmit}>
      <div style={{ ...styleDiv, margin: "0px" }}>
        <h5>Version Info</h5>
        <Controls.Input
          name="name"
          value={values.name}
          label="Name"
          type="text"
          onChange={handleOnChange}
          style={{ marginTop: "20px" }}
          error={errors.name}
        />

        {values.typeSpeakerId !== null && values.typeSpeakerId !== undefined ? (
          <Controls.Select
            name="typeSpeakerId"
            label="Speaker Type"
            value={values.typeSpeakerId}
            onChange={handleOnChange}
            options={typeSpeakers}
            style={{ marginTop: "20px" }}
            disabled={recordForEdit !== null ? true : false}
            error={errors.typeSpeakerId}
          />
        ) : null}

        {values.environment !== null && values.environment !== undefined ? (
          <Controls.Select
            name="environment"
            label="Environment"
            value={values.environment}
            onChange={handleOnChange}
            options={envOption}
            disabled={recordForEdit !== null ? true : false}
            style={{ marginTop: "20px" }}
          />
        ) : null}

        <Controls.Input
          name="versionName"
          value={values.versionName}
          label="Version Name"
          type="text"
          onChange={handleOnChange}
          style={{ marginTop: "20px" }}
          error={errors.versionName}
        />
        <Controls.Input
          name="versionCode"
          value={values.versionCode}
          label="Version Code"
          type="text"
          onChange={handleOnChange}
          style={{ marginTop: "20px" }}
          error={errors.versionCode}
        />
        <Controls.Input
          name="pathFile"
          value={values.pathFile}
          label="Path File"
          disabled={true}
          type="text"
          onChange={handleOnChange}
          style={{ marginTop: "20px", width: "100%" }}
          error={errors.pathFile}
        />

        <input
          style={{ display: "none" }}
          type="file"
          name="file-upload"
          className="form-control"
          onChange={handleFile}
          ref={fileInputRef}
          onClick={(event) => {
            event.target.value = null;
          }}
        ></input>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Controls.Button
            text="Chọn File"
            sx={{ width: "30%" }}
            // sx={{ width: "30%", padding: "0", margin: "15px 0" }}
            onClick={handleChangeFile}
            disabled={loading ? true : false}
          />
          {statusUpload !== statusUploadFile.nothing ? (
            <div
              style={{
                marginRight: "5px",
                marginLeft: "5px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                width: "50%",
              }}
            >
              {files[0]?.name || values.pathFile}
            </div>
          ) : null}

          {statusUpload === statusUploadFile.nothing ? (
            <Box
              sx={{ position: "relative", textAlign: "center", width: "30%" }}
            ></Box>
          ) : (
            <Tooltip title="Nhấn để upload file speaker">
              <Box
                sx={{ position: "relative", textAlign: "center", width: "30%" }}
              >
                <Fab
                  aria-label="save"
                  color="primary"
                  sx={buttonSx}
                  onClick={handleButtonClick}
                >
                  {showIconUploadByStatus(statusUpload)}
                </Fab>

                {statusUpload === statusUploadFile.error ? (
                  <p style={{ color: "red" }}>upload thất bại</p>
                ) : statusUpload === statusUploadFile.success ? (
                  <p style={{ color: "green" }}>upload thành công</p>
                ) : null}

                {loading && (
                  <CircularProgress
                    size={68}
                    sx={{
                      color: green[500],
                      position: "absolute",
                      top: -6,
                      left: 48,
                      zIndex: 1,
                    }}
                  />
                )}
              </Box>
            </Tooltip>
          )}
        </div>

        <Controls.Input
          name="checksum"
          value={values.checksum}
          label="Checksum"
          type="text"
          disabled={true}
          onChange={handleOnChange}
          style={{ marginTop: "20px" }}
          error={errors.checksum}
        />
        <Controls.Input
          name="packageName"
          value={values.packageName}
          label="Package Name"
          type="text"
          onChange={handleOnChange}
          style={{ marginTop: "20px" }}
          error={errors.packageName}
        />

        <Controls.Select
          name="action"
          value={values.action}
          label="Action"
          onChange={handleOnChange}
          options={speakerTypeOption}
          style={{ marginTop: "20px" }}
          error={errors.type}
        />

        <Accordion
          sx={{
            marginTop: "10px",
            marginBottom: "10px",
            color: "var(--txt-color)",
            backgroundColor: "var(--main-bg)",
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography>Group</Typography>
          </AccordionSummary>

          <AccordionDetails
            sx={{
              height: "200px",
              overflowY: "auto",
            }}
          >
            <Controls.MultipleCheckbox
              name="releaseGroupIds"
              label="Groups"
              value={values.releaseGroupIds}
              onChange={handleOnChange}
              options={groups}
            />
          </AccordionDetails>
        </Accordion>
      </div>

      <div>
        <Controls.Button
          sx={{ width: "100%", marginTop: "20px" }}
          type="submit"
          text="Submit"
        />
      </div>
    </Form>
  );
}

export default ReleaseSpeakerVersionForm;
